import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../settings.service';
import { LoginService } from '../login.service';

@Component({
    selector: 'app-exams-names',
    templateUrl: './exams-names.component.html',
    styleUrls: ['./exams-names.component.scss'],
    standalone: false
})
export class ExamsNamesComponent implements OnInit {
  exams = [];
  newExam = { examName: '', Price: '', Color: '', Length: '', examType: '', AutoIndex: null,users:'' };
  error=false

  constructor(public settingsService:SettingsService,public ls:LoginService) { }

  async ngOnInit() {
    // this.exams=await this.settingsService.getExams()
  }

  
  editExam(exam) {
    exam.isEditing = true;
  }

  async saveChanges(exam) {
    try {
      const result = await this.settingsService.updateExam(exam);
      if (result['status']=='ok') {
        this.error=false;
        exam.isEditing = false;

      }
    } catch (error) {
      console.error('Error during the update exam details:', error);
      this.error=true
    }
  }

  async saveNewExam() {
    if (!this.newExam.examName || this.newExam.examName.trim().length === 0) {
      alert('Exam name is required.');
      return;
    }
    try {
    const result =await this.settingsService.saveNewExam(this.newExam)
    if (result['status']=='ok') {
      this.error=false;
      this.newExam = { examName: '', Price: '', Color: '', Length: '', examType: '', AutoIndex: null,users:'' };
      // this.exams=await this.settingsService.getExams()
      

    }
  } catch (error) {
    console.error('Error during the save New Exam', error);
    this.error=true
  }
  }


  getExamTypes(){
    return this.settingsService.getDefault()
  }

}
